import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pt-2 pl-2" }
const _hoisted_2 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_3 = ["viewBox"]
const _hoisted_4 = ["xlink:href", "height", "width"]
const _hoisted_5 = ["points", "onClick"]
const _hoisted_6 = {
  key: 1,
  class: "fill-height pa-2"
}
const _hoisted_7 = { class: "title font-weight-bold" }
const _hoisted_8 = { style: {"margin-left":"-2vw","margin-right":"-2vw"} }
const _hoisted_9 = { style: {"text-align":"center","width":"100%"} }
const _hoisted_10 = { style: {"position":"relative","width":"100%","height":"100%","padding":"0","padding-bottom":"141.4516129032258%"} }
const _hoisted_11 = ["viewBox"]
const _hoisted_12 = ["xlink:href", "height", "width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$vuetify.display.mobile)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "7",
                class: "pr-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { class: "default_card_wm elevation-0 pt-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DocumentMenu, {
                        MenuOptions: _ctx.documentMenuOptions,
                        onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                        onZoomOut: _cache[1] || (_cache[1] = ($event: any) => (_ctx.zoomManager.zoomOut())),
                        onResetZoom: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomManager.resetZoom())),
                        onRotateLeft: _cache[3] || (_cache[3] = ($event: any) => (
                                _ctx.documentPdfRotation = _ctx.rotate(
                                    'left',
                                    _ctx.zoomManager,
                                    _ctx.documentPdfRotation,
                                )
                            )),
                        onRotateRight: _cache[4] || (_cache[4] = ($event: any) => (
                                _ctx.documentPdfRotation = _ctx.rotate(
                                    'right',
                                    _ctx.zoomManager,
                                    _ctx.documentPdfRotation,
                                )
                            )),
                        onZoomIn: _cache[5] || (_cache[5] = ($event: any) => (_ctx.zoomManager.zoomIn())),
                        onDownload: _cache[6] || (_cache[6] = ($event: any) => (_ctx.startDownloadFile())),
                        onDelete: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteDocumentDialog = true))
                      }, null, 8, ["MenuOptions"]),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          (_ctx.isPDF)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                class: "d-flex justify-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ossPdf, {
                                    documentId: _ctx.document.id
                                  }, null, 8, ["documentId"])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "12",
                                style: {"max-height":"85vh","overflow-y":"auto"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    (_ctx.document)
                                      ? (_openBlock(), _createElementBlock("svg", {
                                          key: 0,
                                          id: "svg-document-chat",
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "100%",
                                          viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                          style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                                        }, [
                                          _createElementVNode("g", null, [
                                            _createElementVNode("image", {
                                              id: "svg-image-document-chat",
                                              "xlink:href": _ctx.document.signedUrl,
                                              x: "0",
                                              y: "0",
                                              height: `${_ctx.imageHeight}px`,
                                              width: `${_ctx.imageWidth}px`
                                            }, null, 8, _hoisted_4),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.svgVariants, (variant, index) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variant.coordinates, (coord, index2) => {
                                                  return (_openBlock(), _createElementBlock("polygon", {
                                                    key: `coord-${_ctx.document.id}-${index}-${index2}`,
                                                    ref_for: true,
                                                    ref: `variants-${index}-${index2}`,
                                                    points: _ctx.getPoints(coord),
                                                    style: _normalizeStyle(
                                                            variant.active
                                                                ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                                                : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                        ),
                                                    onClick: _withModifiers(($event: any) => (
                                                            variant.active
                                                                ? ''
                                                                : _ctx.showCorrespondingField({
                                                                      variant,
                                                                      currentIndex: index,
                                                                      copyIndex: index2,
                                                                  })
                                                        ), ["stop"]),
                                                    class: _normalizeClass(variant.focus ? 'highlighted' : '')
                                                  }, null, 14, _hoisted_5))
                                                }), 128))
                                              ], 64))
                                            }), 256))
                                          ])
                                        ], 8, _hoisted_3))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.associatedFields.show)
                    ? (_openBlock(), _createBlock(_component_v_list, {
                        key: 0,
                        style: _normalizeStyle(_ctx.svgPosition)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associatedFields.fields, (field, key, index) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: `field-${_ctx.document.id}-${key}-${index}`,
                              onClick: ($event: any) => (_ctx.onFieldAssociation(field, key)),
                              class: "oss-list-item"
                            }, null, 8, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["style"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "5",
                class: "my-0 pl-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important"},
                    class: "default_card_wm elevation-0 rounded-l-0 fill-height"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, {
                        class: "headline",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createTextVNode(" Demandes pour ce document ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { style: {"width":"100%"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "oss-bordered"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Chat, {
                                    id: _ctx.document.chat ? _ctx.document.chat.id : '',
                                    inShowMessage: _ctx.open_chat,
                                    chatTitle: 'Document',
                                    cardMode: true,
                                    showSmartChat: _ctx.wishStatus !== 'DENIED',
                                    onMessageSent: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onMessageSent($event))),
                                    onShowMessageChanged: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onShowMessageChanged($event)))
                                  }, null, 8, ["id", "inShowMessage", "showSmartChat"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.mode != 'GeneralLedger')
                        ? (_openBlock(), _createBlock(_component_v_card_actions, {
                            key: 0,
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn_icon, {
                                icon: "$navigate_before",
                                disabled: _ctx.previousDisabled(),
                                color: "secondary",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.previous()))
                              }, null, 8, ["disabled"]),
                              _createVNode(_component_v_btn_icon, {
                                icon: "$navigate_next",
                                disabled: _ctx.nextDisabled(),
                                color: "secondary",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.next()))
                              }, null, 8, ["disabled"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_oss_dialog, {
            modelValue: _ctx.dialogChooseDownload,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dialogChooseDownload) = $event)),
            title: "Télécharger le document",
            width: "80vw"
          }, {
            actions: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pr-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_primary, {
                        rounded: "",
                        block: "",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => {
                                    _ctx.dialogChooseDownload = false;
                                    _ctx.downloadFile(true);
                                }),
                        size: "x-large"
                      }, {
                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createTextVNode("Original")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "pl-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_primary, {
                        rounded: "",
                        block: "",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => {
                                    _ctx.dialogChooseDownload = false;
                                    _ctx.downloadFile(false);
                                }),
                        size: "x-large"
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode("Marqué")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _cache[24] || (_cache[24] = _createTextVNode(" Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté). "))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_oss_dialog, {
            modelValue: _ctx.deleteDocumentDialog,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
            title: "Supprimer le document",
            error: true,
            onValid: _ctx.deleteDocument,
            validTitle: 'Oui je suis sûr(e)',
            validLoading: _ctx.deleteDocumentLoading,
            width: "800px"
          }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [
              _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir supprimer le document ? ", -1)
            ])),
            _: 1
          }, 8, ["modelValue", "onValid", "validLoading"])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "7",
                style: {"display":"flex"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_switch, {
                    modelValue: _ctx.showDocument,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showDocument) = $event)),
                    "hide-details": "",
                    label: "Afficher le document",
                    class: "my-0 py-0"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window, {
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.step) = $event)),
            class: "fill-height"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_layout, { wrap: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_flex, { xs12: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_form, {
                            ref: "form",
                            modelValue: _ctx.valid,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.valid) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_divider),
                              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.thirdPartyType() +
                                            (_ctx.document.thirdPartyCompany
                                                ? _ctx.document.thirdPartyCompany.name
                                                : "")), 1),
                              _createVNode(_component_v_divider),
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_Chat, {
                                  id: _ctx.document.chat ? _ctx.document.chat.id : '',
                                  inShowMessage: _ctx.open_chat,
                                  chatTitle: 'Document',
                                  cardMode: true,
                                  onMessageSent: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onMessageSent($event))),
                                  onShowMessageChanged: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onShowMessageChanged($event)))
                                }, null, 8, ["id", "inShowMessage"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, {
                "fill-height": "",
                value: 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_layout, { wrap: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_flex, {
                        xs12: "",
                        sm7: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.document.name), 1),
                              (_ctx.document)
                                ? (_openBlock(), _createElementBlock("svg", {
                                    key: 0,
                                    id: "svg-document-validation-mobile",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                    width: "100%",
                                    viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                    style: {"position":"absolute","width":"100%","left":"0","top":"0"},
                                    class: "elevation-2"
                                  }, [
                                    _createElementVNode("image", {
                                      id: "svg-image-document-validation-mobile",
                                      "xlink:href": _ctx.document.signedUrl,
                                      x: "0",
                                      y: "0",
                                      height: `${_ctx.imageHeight}px`,
                                      width: `${_ctx.imageWidth}px`
                                    }, null, 8, _hoisted_12)
                                  ], 8, _hoisted_11))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
  ]))
}